import { render, staticRenderFns } from "./diseaseTypeNewSub.vue?vue&type=template&id=28695d00"
import script from "./diseaseTypeNewSub.vue?vue&type=script&lang=js"
export * from "./diseaseTypeNewSub.vue?vue&type=script&lang=js"
import style0 from "./diseaseTypeNewSub.vue?vue&type=style&index=0&id=28695d00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports